<template>
    <transition name="sideInOut">
        <div class="back-top" v-show="isShow" :data-spm="spmCCode">
            <CustomTransition property="height">
                <div
                    v-show="showBackTop"
                    class="item to-top"
                    data-spm-acode="3010"
                    :data-spm-visible="showBackTop"
                    @click.stop="handleToTop">
                    <span class="icon-image icon-to-top"></span>
                    <span class="text">顶部</span>
                </div>
            </CustomTransition>
            <div v-if="showHome && showBackTop" class="divide-line"></div>
            <a
                v-show="showHome"
                :href="homeUrl"
                data-spm-strict="true"
                class="item to-home"
                @click.stop="handleToHome">
                <span class="icon-image icon-to-home"></span>
                <span class="text">首页</span>
            </a>
        </div>
    </transition>
</template>
<script>
import EventHelper from '../utils/eventHelper'
import Util from '../utils/util'
import Supporter  from '../utils/supporter';
import SohuStat from '../statistics/sohu-stat';
import CustomTransition from '../vue_components/custom-transition.vue'
export default {
    name: 'BackTop',
    props: ['is_index', 'addto_desktop_id', 'backhome_id', 'is_higher', 'webclip_action_id',
        'addto_desktop_id_ios', 'is_show_feedback', 'app_down_type'],
    components: {
        CustomTransition
    },
    data(){
        return {
            isScrollEnd: true,
            showBackTop: false, // 是否展示置顶
            isShowRedDot: false, // 是否展示红点
        }
    },
    computed:{
        isShow(){
            const isHasComp =  this.showHome || this.showBackTop
            return this.isScrollEnd && isHasComp
        },
        showHome(){
            const isInApp = Supporter.isMSOHU
            return !this.is_index && !isInApp
        },
        backTopClass(){
            return {
                'item-show': this.showBackTop,
                'item-hide': !this.showBackTop
            }
        },
        homeUrl(){
            const homeUrlMap = {
                test: 'https://test-m.sohu.com/fasttpl',
                pre: 'https://pre-m.sohu.com/fasttpl',
                prod: 'https://m.sohu.com'
            }
            const env = Util.getEnvironment()
            const homeUrl = homeUrlMap[env] || homeUrlMap.prod
            return homeUrl
        },
        spmCCode(){
            return 'fx'
        }
    },
    methods:{
        initEvent(){
            const limit = window.screen.availHeight
            let scrollTimer = 0 // 滚动定时器
            EventHelper.addHandler(window, 'scroll', Util.throttle(() => {
                const disTop = window.scrollY
                this.showBackTop = disTop >= limit
                this.isScrollEnd = false
                // 监听滚动停止事件
                scrollTimer && clearTimeout(scrollTimer)
                scrollTimer = setTimeout(() => {
                    console.log('停止滑动')
                    this.isScrollEnd = true
                    scrollTimer && clearTimeout(scrollTimer)
                }, 200)
            }, 150))
        },
        /**
         * @description 初始化小红点
         */
        initRedDot(){
            let date = new Date();
            date=`${date.getFullYear()}${date.getMonth()}${date.getDate()}`;
            if(Supporter.isSupportLocalStorage && (!localStorage.backtopDate || localStorage.backtopDate != date)) {
                this.isShowRedDot = true;
            }
        },
        /**
         * @description 取消红点，并设置一天之内不再展示
         */
        cancelRedDot(){
            this.isShowRedDot = false;
            let date = new Date();
            date=`${date.getFullYear()}${date.getMonth()}${date.getDate()}`;
            if(Supporter.isSupportLocalStorage && (!localStorage.getItem('backtopDate') || localStorage.getItem('backtopDate') != date)) {
                localStorage.setItem('backtopDate', date);
            }
        },
        handleToTop(){
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
        handleToHome(){
            this.cancelRedDot()
            if(this.backhome_id) {
                SohuStat.sendActionStat(this.backhome_id);
            }
        },
        burryCode(){
            this.$nextTick(() => {
                window?.sohuSpm?.domDidChange({
                    target: this.spmCCode,
                })
            })
        },
    },
    mounted(){
        this.initEvent()
        this.burryCode()
    },
}
</script>
<style lang="less" scoped>
@textColor: #E67A00;
@iconWidth: 32px; /*px*/
@iconHeight: 32px; /*px*/
@textSize: 22px; /*px*/
@textFamily: PingFangSC-Medium, PingFang SC;
@highLayer: 3;
@itemSize: 64px; /*px*/
@containerWidth: 88px; /*px*/
.back-top{
    width: @containerWidth; /*px*/
    background: #F7F7ED;
    border-radius: 42px; /*px*/
    border: 2px solid rgba(230,122,0,0.15); /*px*/
    box-sizing: border-box;
    position: fixed;
    bottom: 216px; /*px*/
    right: 16px; /*px*/
    z-index: @highLayer;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    padding: 10px 0px; /*px*/
    .item{
        width: @itemSize; /*px*/
        height: @itemSize; /*px*/
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        transition: all 0.2s ease-in-out;
        .icon-image{
            width: @iconWidth; /*px*/
            height: @iconHeight; /*px*/
        }
        .text{
            max-width: 100%;
            height: 32px; /*px*/
            font-size: 22px; /*px*/
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #E67A00;
            line-height: 32px; /*px*/
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .icon-to-top{
            background: url('../less/images/icon_up@2x.png') no-repeat center;
            background-size: contain;
            transform-origin: center bottom;
        }
        .icon-to-home{
            background: url('../less/images/icon_homepage@2x.png') no-repeat center;
            background-size: contain;
            transform-origin: center top;
        }
    }
    .item-show{
        height: @itemSize; /*px*/
        visibility: visible;
        opacity: 1;
    }
    .item-hide{
        height: 0px !important; /*px*/
        visibility: hidden;
        opacity: 0;
    }
    .divide-line{
        width: 48px; /*px*/
        height: 2px; /*px*/
        background: #E67A00;
        opacity: 0.15;
        margin: 10px 0px; /*px*/
    }
}
.sideInOut-enter-to,.sideInOut-leave-active{
    opacity: 1;
    visibility: visible;
}
.sideInOut-enter-active{
    transition: all 0.3s ease-in-out;
}
.sideInOut-leave-active{
    transition: all 0.3s ease-in-out;
}
.sideInOut-enter,.sideInOut-enter-from,.sideInOut-leave-to{
    opacity: 0;
    visibility: hidden;
}
</style>